var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import * as Util from '../../util';
var NOMBRE_EVENTO_PULSAR = Util.is_touch_device() ? 'onTouchEnd' : 'onClick';

var BotonNavegacion = function BotonNavegacion(_ref) {
  var activo = _ref.activo,
      direccion = _ref.direccion,
      onPulsar = _ref.onPulsar;
  var eventHandlers = {};

  if (onPulsar) {
    eventHandlers[NOMBRE_EVENTO_PULSAR] = function (e) {
      e.preventDefault();
      onPulsar(e);
    };
  }

  var clases = [direccion === 'izquierda' ? 'navegacionMiniaturasI' : 'navegacionMiniaturasD', activo ? '' : 'desactivado'].join(' ');
  return React.createElement('div', _extends({
    className: clases
  }, eventHandlers));
};

BotonNavegacion.propTypes = process.env.NODE_ENV !== "production" ? {
  activo: t.bool,
  direccion: t.string,
  onPulsar: t.func
} : {};
export default BotonNavegacion;